
    <!--
 * 横版-页面导航
 * @LastEditTime: Fri Apr 04 2025 19:11:26 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_Z2C155"  v-show="compData.isShow" :class="[`normal pageRouter`,`u_c_Z2C155`]" ><div id="u_c_3A3W56"  v-for="(btnItem, btnI) in compData.btnList" :key="btnI" :class="[`normal`,`u_c_3A3W56`]" ><a id="u_c_2XBF57" href="javascript:;" :style="`${ btnItem.pic ? `background-image:url(${ btnItem.pic })` : '' }`" :data-target="btnItem.block" :class="[`${ btnItem.cur ? 'cur' : '' }`,`normal btn-light nav-btn `,`u_c_2XBF57`]" @click="u_c_2XBF57_event_F9W931($event,btnI,btnItem.block,btnItem.link)"><div id="u_c_A2TD58"  v-html="pageData.isEdit ? btnItem.text : getBtnText(btnItem)" :class="[`normal`,`u_c_A2TD58`]" ></div></a></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const curRouterCompMap = inject("curRouterCompMap",{});
    const COMP_DATA_LANG = {"default":{"btnList":[{"block":"u_c_K1XQ135","link":(utils.updateLinkParams('-',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"返回\n首屏"},{"block":"u_c_NYO465","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"完成任务\n送福利"},{"block":"u_c_UBXT19","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"连续登录\n送大奖"}],"isShow":true},"en-US":{"btnList":[{"block":"home","link":(utils.updateLinkParams('-',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"Champion's Return"},{"block":"task","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"Quest Center"},{"block":"sign","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"PC Login Rewards: Fashion"}],"isShow":true},"th-TH":{"btnList":[{"block":"home","link":(utils.updateLinkParams('-',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"ผู้กล้าหวนคืน"},{"block":"task","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"ศูนย์เควส"},{"block":"sign","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"เช็คอิน PC แจกชุดแฟชั่น"}],"isShow":true},"ru-RU":{"btnList":[{"block":"home","link":(utils.updateLinkParams('-',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"Возвращение\nчемпиона"},{"block":"task","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"Центр\n заданий"},{"block":"sign","link":(utils.updateLinkParams('',{cid:'activity',scid:'mupc0331',gameId:390},true)),"text":"Награды за вход на ПК: Наряды"}],"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '页面导航';

    // 自定义setup - 开始
    const getCurLink = inject("getCurLink", (link) => {})

const init = () => {
  compData.isShow = true;
  if (bridge.runInsdk()) {
    compData.btnList = compData.btnList.filter((item) => {
      return item.block != "pay";
    });
  }
  compData.btnList.forEach((item) => {
    if (item.link) {
      item.link = utils.getStoreLinkWithCidScid({
        link: item.link,
        paramsObj: {
          language: curLang,
          gameId: pageData.gameId,
        },
        pageId: pageData.pageId,
      })
    }
  })
}

init()
// 获取按钮名称
const getBtnText = (item) => {
  if (item.block === "pay") {
    return getLangTxt("goPay");
  }
  if (item.block === "download") {
    return getLangTxt("downloadGame");
  }
  return item.text;
};
let sectionPosition = []
onMounted(() => {
  let curScroll = document.documentElement.scrollTop
  compData.btnList.forEach((item, index) => {
    if (item.block && !["pay", "download", "jump"].includes(item.block)) {
      let _ele = document.getElementById(curRouterCompMap[item.block].uuid)
      if (_ele) {
        let _p = _ele.getBoundingClientRect()
        sectionPosition.push({
          top: Math.floor(_p.top + curScroll + _p.height / 3),
          realTop: Math.floor(_p.top + curScroll),
          index,
        })
      }
    }
  })
  const throttledFn = vueUse.useThrottleFn(() => {
    let curScroll = document.documentElement.scrollTop
    let curIndex = sectionPosition.findIndex((item) => item.top > curScroll)
    if (~curIndex) {
      compData.btnList.forEach((item, index) => {
        if (index == sectionPosition[curIndex].index) {
          item.cur = 1
        } else {
          item.cur = 0
        }
      })
    }
  })
  window.addEventListener("scroll", throttledFn)
  throttledFn()
});
      // 自定义元素12XBF57的click事件
      const u_c_2XBF57_event_F9W931= async (e,index,block,link)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: `导航栏-${index}`,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

if (!block || ["pay", "download", "jump"].includes(block)) {
  bridge.open(link)
} else {
  let curTopIndex = sectionPosition.findIndex(
    (item) => item.index == index
  )
  if (~curTopIndex) {
    window.scrollTo({
      top: sectionPosition[curTopIndex].realTop,
      behavior: "smooth",
    })
  }
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_Z2C155.normal{
position:fixed;
right:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473563-48.png);
flex-direction:column;
top:0;
height:100%;

}
}.default{
.u_c_3A3W56.normal{
position:relative;
display:flex;
flex:0.05vw;

}
}.default{
.u_c_2XBF57.normal{
position:relative;
display:flex;
width:10.47vw;
height:auto;
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_2XBF57.normal.cur{
filter:brightness(1.4);
background:no-repeat 0 50%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742909277314-15.png);
background-size:cover;

}
}.default{
.u_c_A2TD58.normal{
position:relative;
font-size:1.41vw;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.en-US{
.u_c_Z2C155.normal{
position:fixed;
right:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473563-48.png);
flex-direction:column;
top:0;
height:100%;

}
}.en-US{
.u_c_3A3W56.normal{
position:relative;
display:flex;
flex:0.05vw;

}
}.en-US{
.u_c_2XBF57.normal{
position:relative;
display:flex;
width:10.47vw;
height:auto;
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_2XBF57.normal.cur{
filter:brightness(1.4);
background:no-repeat 0 50%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742909277314-15.png);
background-size:cover;

}
}.en-US{
.u_c_A2TD58.normal{
position:relative;
font-size:1.41vw;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.th-TH{
.u_c_Z2C155.normal{
position:fixed;
right:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473563-48.png);
flex-direction:column;
top:0;
height:100%;

}
}.th-TH{
.u_c_3A3W56.normal{
position:relative;
display:flex;
flex:0.05vw;

}
}.th-TH{
.u_c_2XBF57.normal{
position:relative;
display:flex;
width:10.47vw;
height:auto;
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_2XBF57.normal.cur{
filter:brightness(1.4);
background:no-repeat 0 50%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742909277314-15.png);
background-size:cover;

}
}.th-TH{
.u_c_A2TD58.normal{
position:relative;
font-size:1.41vw;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}.ru-RU{
.u_c_Z2C155.normal{
position:fixed;
right:0;
font-size:0;
display:flex;
justify-content:center;
align-items:center;
z-index:5;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742907473563-48.png);
flex-direction:column;
top:0;
height:100%;

}
}.ru-RU{
.u_c_3A3W56.normal{
position:relative;
display:flex;
flex:0.05vw;

}
}.ru-RU{
.u_c_2XBF57.normal{
position:relative;
display:flex;
width:10.47vw;
height:auto;
justify-content:center;
align-items:center;
text-decoration:none;

}

.u_c_2XBF57.normal.cur{
filter:brightness(1.4);
background:no-repeat 0 50%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742909277314-15.png);
background-size:cover;

}
}.ru-RU{
.u_c_A2TD58.normal{
position:relative;
font-size:1.41vw;
color:#f1f1f1;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.2;

}
}
</style>
